import { StrictLocalizeFunction } from "../localization/localize";

export const CANADA_PROVINCE_SHORTHAND_TO_NAME = (
  strictLocalize: StrictLocalizeFunction
) =>
  ({
    AB: strictLocalize({
      defaultMessage: "Alberta",
      description: { text: "Canadian province" },
    }),
    BC: strictLocalize({
      defaultMessage: "British Columbia",
      description: { text: "Canadian province" },
    }),
    MB: strictLocalize({
      defaultMessage: "Manitoba",
      description: { text: "Canadian province" },
    }),
    NB: strictLocalize({
      defaultMessage: "New Brunswick",
      description: { text: "Canadian province" },
    }),
    NL: strictLocalize({
      defaultMessage: "Newfoundland",
      description: { text: "Canadian province" },
    }),
    NS: strictLocalize({
      defaultMessage: "Nova Scotia",
      description: { text: "Canadian province" },
    }),
    NT: strictLocalize({
      defaultMessage: "Northwest Territories",
      description: { text: "Canadian territory" },
    }),
    NU: strictLocalize({
      defaultMessage: "Nunavut",
      description: { text: "Canadian territory" },
    }),
    ON: strictLocalize({
      defaultMessage: "Ontario",
      description: { text: "Canadian province" },
    }),
    PE: strictLocalize({
      defaultMessage: "Prince Edward Island",
      description: { text: "Canadian province" },
    }),
    QC: strictLocalize({
      defaultMessage: "Quebec",
      description: { text: "Canadian province" },
    }),
    SK: strictLocalize({
      defaultMessage: "Saskatchewan",
      description: { text: "Canadian province" },
    }),
    YT: strictLocalize({
      defaultMessage: "Yukon",
      description: { text: "Canadian territory" },
    }),
  } as const);
